<template>
  <div>
    <van-popup
      class="nickContent"
      v-model="showCon"
      position="bottom"
      :style="{ height: '50%' }"
    >
        <div class="selectTitle">
          {{nickType1==2? '删除账号':'切换账号'}}
          <div  @click="closeModal" style="position: absolute;left: 20px;top: 2px;font-size: 16px" >取消</div>
          <div  @click="enterSelect" style="position: absolute;right: 20px;top: 2px;font-size: 16px;color: #576b95" >确认</div>
        </div>
        <div style="overflow-y: auto;height: 100%">
          <van-radio-group v-model="seleName" class="bigBox">
            <van-cell-group>
              <van-cell v-for="(item,index) in listItem"  clickable @click="selcetItem(item,index)" :class="{active:activeIndex==index}">
                <template #title>
                  <span class="custom-title">
                      <img v-if="item.trend==null" style="width: 100%" src="@/assets/logo.png">
                      <span v-else>{{item.trend}}</span>
                  </span>
                  <div class="custon-content">
                    <span>{{item.account}}</span>
                    <span>{{item.station_name}}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="item.account" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
    </van-popup>
  </div>
</template>

<script>
  import { Dialog, Toast } from 'vant';
  import { switchUserRelation , delUserRelation,getUserRelation} from '@/api/station';
  import { mapActions } from 'vuex';
  import { USER_SIGNIN,USER_SIGNOUT } from '@/store/user';
  import { logOutApi } from '@/api/user';
  import { MODIFY_WXBIND,MODIFY_USEVIOCE } from '@/store/appconf';
  export default {
    name: "switchCard",
    props: ['nickType','getCardListAjax_type'],
    watch:{
      nickType:function (newVal,oldVal) {
        this.nickType1=newVal
      },
      getCardListAjax_type:function(newVal,oldVal) {
        // console.log('=======',newVal, oldVal);
        this.getCardListAjax()
      }
    },
    data(){
      return {
        showCon:false,
        listItem:[],
        seleName:'',
        sendData:null,
        // switchList:[],
        nickType1:null,
        activeIndex:-1
      }
    },
    mounted() {
      // this.seleName =JSON.parse(localStorage.getItem('g7user')).username;
      this.getCardListAjax()
    },
    methods:{
      ...mapActions([USER_SIGNIN,MODIFY_WXBIND,MODIFY_USEVIOCE,USER_SIGNOUT]),
      fakeingStr(str,index){
        const _this = this;
        for(let i = str.length;i>=0;i--){
          if('东'.indexOf(str[i])>=0){
            _this.listItem[index].trend = str[i]
            break ;
          }else if('南'.indexOf(str[i])>=0){
            _this.listItem[index].trend = str[i]
            break ;
          }else if('西'.indexOf(str[i])>=0){
            _this.listItem[index].trend =  str[i]
            break ;
          }else if('北'.indexOf(str[i])>=0){
            _this.listItem[index].trend = str[i]
            break ;
          }else{
            _this.listItem[index].trend = null
          }
        }
        // console.log(_this.listItem);
      },
      getCardListAjax(){
        let params = {};
        const _this = this;
        getUserRelation(params).then(res=>{
          if(res.code==0){
            this.listItem = res.data||[];
            for(let i = 0;i<this.listItem.length;i++){
              _this.fakeingStr(this.listItem[i].station_name,i)
            }
            if(this.listItem.length>0){
              _this.$parent.showGrop()
            }else{
              _this.$parent.hideGrop()
            }
          }
        })
      },
      switchUserRelationAjax(){
        let params = {username:this.sendData.account};
        switchUserRelation(params).then(res=>{
          this.dealWithLogin(res)
        })
      },
      delUserRelationAjax(){
        let params = {username:this.sendData.account};
        const _this = this;
        delUserRelation(params).then(res=>{
          if(res.code==0){
            Toast('删除成功');
            setTimeout(()=>{
              if(params.username==JSON.parse(localStorage.getItem('g7user')).username){//删除账号是当前的账号-跳转登录页
                _this.loginOut()
              }else{
                _this.showCon=false;
                _this.getCardListAjax();
              }
            },1000)
          }
        })
      },
      loginOut(){
        let parmas = {};
        if(!this.isWeixin) {
          parmas.from = 'pdah5';
          parmas.gas_token = localStorage.getItem('gas_token') || '';
        }
        logOutApi(parmas).then(res => {
          if (res.code === 0) {
            Toast('退出成功');
            this.USER_SIGNOUT();
            setTimeout(() => {
              let gas_token = localStorage.getItem('gas_token');
              if(gas_token){
                if(location.href.indexOf('test') > -1 || location.href.indexOf('172.') > -1) {
                  window.location.href = 'https://gas.test.chinawayltd.com/gas_android/'
                } else {
                  window.location.href = 'https://gas.huoyunren.com/gas_android/'
                }
              }else {
                this.$router.replace('/login')
              }
            }, 1000)
          } else {
            Toast(res.msg);
          }
        }).catch(err => {
          console.log(err.message)
        })
      },
      closeModal(){
        this.showCon=false;
      },
      selcetItem(t,i){
        this.seleName=t.account;
        this.sendData = t;
        this.activeIndex = i;
      },
      callMethod() {
        this.showCon=true;
      },
      enterSelect(){
        if(this.nickType==2){//删除
          if(this.sendData==null){
            Toast('请选择要删除的账号');
          }else{
            this.delUserRelationAjax()
          }
        }else{//切换
          if(this.sendData==null){
            Toast('请选择要切换的账号');
          }else{
            this.switchUserRelationAjax()
          }
        }

      },
      dealWithLogin(res) {
        const _this = this
        if (res.code === 0) {
          let u_info = {
            token: res.data.token,
            openid: res.data.openid,
            truename: res.data.truename,
            id: res.data.id,
            station_id: res.data.station_id,
            username:res.data.username
          }
          this.MODIFY_WXBIND(res.data.is_bind_wx);
          this.MODIFY_USEVIOCE(res.data.is_broadcast_voice);
          this.USER_SIGNIN(u_info);
          Toast('切换成功！');
          this.showCon=false;
          if(_this.$route.name=='index'){
            window.location.reload();
          }else{
            _this.$router.replace('/')
          }
        }else if(res.code=='1511'||res.code=='1512'||res.code=='1513'){
          Dialog.confirm({
            message: res.msg,
            width: '8.5333rem',
            confirmButtonText:'先不退了',
            confirmButtonColor:'#532FE6',
            cancelButtonText:'退出登录',
            cancelButtonColor:'#333',
            className:'dialog-style'
          }).then(() => {
            // this.callCamera(); confirm
            _this.showCon=false;
            _this.getCardListAjax();
          }).catch(() => {//cancel
            _this.showCon=false;
            _this.loginOut()
          });
        }else{
          Toast(res.msg);
        }
      },
    }
  }
</script>
<style>
  .van-radio{
    z-index: 99999;
  }
  .van-radio__icon .van-icon{
    border-color:  #3f51b5;
  }
</style>
<style scoped lang="less">
  .active{
    background: #6544f033;
    font-weight: 700 !important;
  }
  .bigBox{
    padding-bottom: 40px;
    /deep/ .van-cell.van-cell--clickable{
      padding-top: 14px;
      padding-bottom: 0;
    }
  }
  .selectTitle{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    left: 0;
    top: 50%;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #ffff;
  }
  .custom-title{
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    vertical-align: top;
    span{
      font-size: 24px;
      font-weight: 700;
      background: #6645f1de;
      width: 98%;
      display: inline-block;
      height: 98%;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      color: #fff;
    }
  }
  .nickContent{
    overflow: unset;
    /deep/ .van-cell__title{
      flex: none;
    }
  }
  .custon-content{
    display: inline-block;
    vertical-align: 10px;
    width: 260px;
    padding-left: 10px;
    span{
      display: block;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
